<template>
  <div class="movement-control-container">
    <div
      class="movement-control up"
      :class="{ 'inactive': inactiveUp }"
      @click="$emit('movementUp')"
    >
      <span class="movement-control-icon"></span>
    </div>
    <div
      class="movement-control down"
      :class="{ 'inactive': inactiveDown }"
      @click="$emit('movementDown')"
    >
      <span class="movement-control-icon"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormMovementControl',
  props: {
    inactiveUp: {
      type: Boolean,
      default() {
        return false;
      },
    },
    inactiveDown: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
</script>

<style lang="sass" scoped>
  .movement-control-container
    width: auto
    height: auto
    position: static
    display: flex
    flex-direction: row
    flex-wrap: wrap

    +respond-to("medium")
      width: 50px
      height: 80px
      position: absolute
      left: -70px
      top: 20px
      flex-direction: column
      justify-content: space-around

  .movement-control
    width: 60px
    height: 40px
    margin-right: 20px
    position: relative
    border-radius: 100px
    background-color: #26263a
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15)

    &:hover
      background-color: #31334d
      cursor: pointer

    +respond-to("medium")
      width: auto
      height: 48%
      margin: 0

    &.up
      +respond-to("medium")
        border-radius: 30px 30px 0 0

    &.down
      +respond-to("medium")
        border-radius: 0 0 30px 30px

    &.inactive
      &:hover
        background-color: #26263a
        cursor: default

  .movement-control-icon
    width: 100%
    height: 100%
    position: absolute
    background-repeat: no-repeat
    background-position: center

    #{'.up'} &
      background-image: url('~@/assets/svg/common/arrow-up.svg')

    #{'.down'} &
      background-image: url('~@/assets/svg/common/arrow-down.svg')

    #{'.inactive'} &
      opacity: .25
</style>
